Drupal.behaviors.AutryCoverImage = {
  attach: function (context, settings) {
    const elements = once('AutryCoverImage', '.autry-field-cover-image')
    elements.forEach(figure => {
      figure.addEventListener('click', event => {
        if (event.target.tagName.toUpperCase() === 'BUTTON') {
          figure.querySelector('figcaption').classList.toggle('is-expanded')
          const isExpanded =
            event.target.getAttribute('aria-expanded') === 'true'
          event.target.setAttribute('aria-expanded', !isExpanded)
        }
      })
    })
  }
}
